import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import styles from './ResetPassword.module.scss';
import { useForm, SubmitHandler, useFormState } from 'react-hook-form';
import { Button, Form, FormfieldString, LoginBox, Paragraph } from 'ui/components';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

interface FormData {
	email: string;
}

export interface ResetPasswordProps {
	className?: string;
	heading?: string;
	text?: string;
	buttonText: string;
	buttonTextResend: string;
	requestSentMessage: string;
}

export const ResetPassword: React.FC<ResetPasswordProps> = ({
	// className,
	heading,
	text,
	buttonText,
	buttonTextResend,
	requestSentMessage,
}) => {
	const dictionary = useContext(DictionaryContext);

	const [requestSent, setRequestSent] = useState(false);

	// FORM HANDLING
	// const [allErrors, setallErrors] = useState(0);
	const [errorSummary, setErrorSummary] = useState(0);
	const { register, handleSubmit, control } = useForm<FormData>();

	const onSubmit: SubmitHandler<FormData> = (data) => {
		alert(`Thank for submitting, ${JSON.stringify(data)}`);
		setRequestSent(true);
	};

	const { errors } = useFormState({
		control,
	});

	const onError = (data) => {
		const totalErrors = Object.keys(data).length;
		setErrorSummary(totalErrors);
		// setallErrors(data);
	};

	const errorMessage = dictionary.getValue('Form.ErrorMessage', null, 'This field is required');
	// / FORM HANDLING

	return (
		<LoginBox heading={heading}>
			{text && <Paragraph className="u-bottom-margin--lg">{text}</Paragraph>}
			<Form onSubmit={handleSubmit(onSubmit, onError)} errorSummary={errorSummary} errorSummaryPosition="bottom">
				<FormfieldString
					id="email"
					name="email"
					label={dictionary.getValue('Form.EnterYourEmail', null, 'Enter your e-mail')}
					type="email"
					register={register}
					className={classNames(styles.LoginBox_Formfield, 'u-bottom-margin--md')}
					state={
						errors.email
							? {
									hasError: true,
									required: true,
							  }
							: { required: true }
					}
					errorMessage={errorMessage}
					pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
				/>

				<Button
					className={classNames(styles.LoginBox_button)}
					style="primary"
					type="submit"
					aria-label={requestSent ? buttonTextResend : buttonText}
				>
					{requestSent ? buttonTextResend : buttonText}
				</Button>
				{requestSent && (
					<Paragraph className={classNames(styles.ResetPassword_requestConfirmation, 'u-top-margin--sm')}>{requestSentMessage}</Paragraph>
				)}
			</Form>
		</LoginBox>
	);
};
